module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('doc-section', {
    attrs: {
      "id": "dropdown",
      "name": "Dropdown"
    }
  }, [_c('div', {
    staticClass: "bs-example"
  }, [_c('dropdown', [_c('strong', {
    slot: "button"
  }, [_vm._v("Action (bold)")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    slot: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#dropdown"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#dropdown"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#dropdown"
    }
  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#dropdown"
    }
  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "text": "Action",
      "type": "primary"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#dropdown"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#dropdown"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#dropdown"
    }
  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#dropdown"
    }
  }, [_vm._v("Separated link")])])]), _vm._v(" "), _c('dropdown', [_c('i', {
    slot: "button"
  }, [_vm._v("Action (italic)")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    slot: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#dropdown"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#dropdown"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#dropdown"
    }
  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#dropdown"
    }
  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "text": "Disabled",
      "type": "warning",
      "disabled": ""
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#dropdown"
    }
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "type": "info"
    }
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    slot: "before"
  }, [_vm._v("Segmented")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#dropdown"
    }
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-group-justified"
  }, [_c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#dropdown",
      "role": "button"
    }
  }, [_vm._v("Left")]), _vm._v(" "), _c('dropdown', [_c('u', {
    slot: "button"
  }, [_vm._v("Dropdown (underlined)")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    slot: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#dropdown"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#dropdown"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#dropdown"
    }
  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#dropdown"
    }
  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#dropdown",
      "role": "button"
    }
  }, [_vm._v("Right")])], 1)], 1), _vm._v(" "), _c('doc-code', [_vm._v("\n    <dropdown text=\"Action\" type=\"primary\">\n      <li><a href=\"#dropdown\">Action</a></li>\n      <li role=\"separator\" class=\"divider\"></li>\n      <li><a href=\"#dropdown\">Separated link</a></li>\n    </dropdown>\n    // For segmented dropdown, ignore text and add a \"before\" slot\n    <dropdown type=\"info\">\n      <button slot=\"before\" type=\"button\" class=\"btn btn-info\">Segmented</button>\n      <li><a href=\"#dropdown\">...</a></li>\n    </dropdown>\n    // In a button group\n    <div class=\"btn-group btn-group-justified\">\n      <a href=\"#dropdown\" class=\"btn btn-default\" role=\"button\">Left</a>\n      <dropdown>...</dropdown>\n      <a href=\"#dropdown\" class=\"btn btn-default\" role=\"button\">Right</a>\n    </div>\n    // Use slots for some elements as native bootstrap\n    <dropdown>\n      // main button limited only to html styling\n      <u slot=\"button\">Action (underlined)</u>\n      <ul slot=\"dropdown-menu\" class=\"dropdown-menu\">\n        <li><a href=\"#dropdown\">Action</a></li>\n        <li><a href=\"#dropdown\">Another action</a></li>\n        <li><a href=\"#dropdown\">Something else here</a></li>\n        <li role=\"separator\" class=\"divider\"></li>\n        <li><a href=\"#dropdown\">Separated link</a></li>\n      </ul>\n    </dropdown>\n  ")]), _vm._v(" "), _c('doc-table', [_c('div', [_c('p', [_vm._v("value (v-model)")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('p', [_vm._v("false")]), _vm._v(" "), _c('p', [_vm._v("Whether show the component.")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("disabled")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("false")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', [_c('p', [_vm._v("text")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("Dropdown button text.")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("type")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("String")]), _vm._v(", one of\n        "), _c('code', [_vm._v("default")]), _vm._v(" "), _c('code', [_vm._v("primary")]), _vm._v(" "), _c('code', [_vm._v("danger")]), _vm._v(" "), _c('code', [_vm._v("info")]), _vm._v(" "), _c('code', [_vm._v("warning")]), _vm._v(" "), _c('code', [_vm._v("success")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("default")])]), _vm._v(" "), _c('p')])]), _vm._v(" "), _c('doc-table', {
    attrs: {
      "type": "Events"
    }
  }, [_c('div', [_c('p', [_vm._v("input")]), _vm._v(" "), _c('p', [_vm._v("("), _c('code', [_vm._v("show:boolean")]), _vm._v(")")]), _vm._v(" "), _c('p', [_vm._v("Return if the dropdown is shown.")])])]), _vm._v(" "), _c('h2', [_vm._v("Usage")]), _vm._v(" "), _c('p', [_vm._v("Just like the examples. With slots you can use it as the "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://getbootstrap.com/javascript/#dropdowns"
    }
  }, [_vm._v("original Bootstrap way")]), _vm._v(".")])], 1)
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5deb86d8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5deb86d8!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/example/dropdownDocs.vue
// module id = 180
// module chunks = 0